import { render, staticRenderFns } from "./StrokeTopRightIcon.vue?vue&type=template&id=3287cb68&"
import script from "./StrokeTopRightIcon.vue?vue&type=script&lang=js&"
export * from "./StrokeTopRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports